import React, { Component } from "react";
import UsersListingView from "./users-listing-view";
import { requestUsersList } from "./users-listing-actions";
import { connect } from "react-redux";

class UserListing extends Component {
  componentDidMount() {
    this.props.requestUsersList({
      asBusinessId: this.props.auth.business_id
    });
  }

  render() {
    const { isFetching, users } = this.props.usersAndPermissions;
    return <UsersListingView isLoading={isFetching} data={users} />;
  }
}

const mapStateToProps = state => ({
  usersAndPermissions: state.usersAndPermissions,
  auth: state.auth
});

const mapDispatchToProps = {
  requestUsersList: requestUsersList
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(UserListing);



// WEBPACK FOOTER //
// ./src/components/users-and-permissions/users-listing/users-listing.js